export default {
    title: 'justifyLeft',
    action: [ 'justifyLeft' ],
    description: 'Justify Left',
    icon: 'Left',
};
